export var MemoModalVariants = function (MemoModalVariants) {
  MemoModalVariants["PAGE"] = "default";
  MemoModalVariants["CARD"] = "card";
  return MemoModalVariants;
}({});